import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { darcula } from "react-syntax-highlighter/dist/esm/styles/prism";

const DEFAULT_CUSTOM_STYLES = {
  width: "fit-content",
  borderRadius: "0.5rem",
  margin: 0,
};

export function CodeSnippet({ code, customStyles = DEFAULT_CUSTOM_STYLES }) {
  return (
    <div className={`flex flex-col gap-2 w-full`}>
      <ReactMarkdown
        components={{
          code({ node, inline, className, children, ...props }) {
            // Return normal codeblock if inline
            if (inline) {
              return (
                <code className={className} {...props}>
                  {children}
                </code>
              );
            }
            // Return highlighted code if language match
            const match = /language-(\w+)/.exec(className || "");
            if (match) {
              const formattedChildren = String(children).replace(/\n$/, "");
              return (
                <SyntaxHighlighter
                  customStyle={customStyles}
                  wrapLines={true}
                  wrapLongLines={true}
                  style={darcula}
                  language={match[1]}
                  PreTag="div"
                  {...props}
                >
                  {formattedChildren}
                </SyntaxHighlighter>
              );
            } else {
              return (
                <code className={className} {...props}>
                  {children}
                </code>
              );
            }
          },
        }}
      >
        {code}
      </ReactMarkdown>
    </div>
  );
}
